import {Component, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {HelperService} from '../../../service/helper.service';
import swal from 'sweetalert2';
import {ApiService,StrongPasswordRegx} from "../../../service/api.service";
import { EncryptionService } from '../../../service/encryption.service';
import {Router} from '@angular/router';
import {CustomPasswordValidator} from '../../../store/custom-password-validator'

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  hide = true;
  hide1 = true;
  hide2 = true;
  changePasswordForm: FormGroup;
  companyId:any;
  constructor(
    private _formBuilder: FormBuilder,
    private Helper: HelperService,private encryptionService: EncryptionService,
    private Api: ApiService, private router: Router,
    private translate: TranslateService
  ) {
    this.changePasswordForm = this._formBuilder.group({
        old_password: [null, [Validators.required]],
        new_password: ['', [Validators.required,Validators.pattern(StrongPasswordRegx)]],
        confirmPassword: [null, [Validators.required]]
      },
      {validator: this.ConfirmedValidator('new_password', 'confirmPassword')},
    );
  }


  get password() {
    return this.changePasswordForm.get('new_password');
  }

  get confpassword() {
    return this.changePasswordForm.get('confirmPassword');
  }

  get current_Password() {
    return this.changePasswordForm.get('old_password');
  }

  changePassword(): void {
    if (this.changePasswordForm.valid) {
      const loginUser = this.encryptionService.getDataFromLocalStorage('NPLoginId');
      this.companyId = JSON.parse(loginUser);
      const body = {
        "customerId" : this.companyId,
        "oldPassword" : this.changePasswordForm.controls['old_password'].value,
        "newPassword" : this.changePasswordForm.controls['confirmPassword'].value,
    }
      this.Helper.toggleLoaderVisibility(true);
      this.Api.setPassword(body).subscribe((data: any) => {
        this.Helper.toggleLoaderVisibility(false);
        if(data.result){
          this.router.navigate(['my-account/edit-profile']);
            swal.fire(
              '',
              this.translate.instant(data.message),
            'success');
        }else{
            swal.fire(
              '',
              this.translate.instant(data.message),
            'info');
        }
       }, (error) => {
         this.Helper.toggleLoaderVisibility(false);
         const e = error.error;
         swal.fire(
           'Info!',
             this.translate.instant(e.message),
           'info'
         );
       });
    }else{
      this.changePasswordForm.markAllAsTouched();
      this.Helper.showMandatoryFieldsPopup();
    }
  }

  ngOnInit(): void {
  }

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors['confirmedValidator']) {
        return;
      } 
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }


}
